import React from 'react';
import { Link } from 'react-router-dom';

const CourseCards = () => {
  const courses = [
    {
      id: 1,
      title: 'NEET',
      subtitle: 'Class 11th, 12th, Repeater',
      description: 'Coaching for NEET with expert faculty, concise notes, and regular mock tests for top performance.',
      image: 'https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=400&h=250&fit=crop',
      icon: '🏥',
    },
    {
      id: 2,
      title: 'JEE',
      subtitle: 'Class 11th, 12th',
      description: 'Focused JEE Main & Advanced prep with strong concepts and problem-solving skills.',
      image: 'https://images.unsplash.com/photo-1635070041078-e363dbe005cb?w=400&h=250&fit=crop',
      icon: '⚡',
    },
    {
      id: 3,
      title: 'MHT-CET',
      subtitle: 'Class 11th, 12th',
      description: 'Targeted MHT-CET program with syllabus coverage and practice sessions.',
      // image: 'https://images.unsplash.com/photo-1523050854058-8df90110c9f1?auto=format&fit=crop',
      image: 'https://images.unsplash.com/photo-1587825140708-dfaf72ae4b04?w=400&h=250&fit=crop',
      icon: '📊',
    },
    {
      id: 4,
      title: 'Foundation',
      subtitle: '6th to 10th',
      description: 'Foundation courses to strengthen Science & Math for future competitive exams.',
      image: 'https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=400&h=250&fit=crop',
      icon: '🏗️',
    },
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Our Courses
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Explore our most trusted coaching programs designed to help you excel in competitive exams
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {courses.map((course) => (
            <div key={course.id} className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
              <div className="relative">
                <img
                  src={course.image}
                  alt={course.title}
                  className="w-full h-48 object-cover"
                />
                <div className="absolute top-4 right-4 bg-primary text-white p-2 rounded-full">
                  <span className="text-2xl">{course.icon}</span>
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-2">
                  {course.title}
                </h3>
                <p className="text-sm text-primary font-medium mb-3">
                  {course.subtitle}
                </p>
                <p className="text-gray-600 mb-4 text-sm">
                  {course.description}
                </p>
                <Link
                  to={`/courses/${course.id}`}
                  className="inline-block bg-primary text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors text-sm font-medium"
                >
                  Learn More
                </Link>
              </div>
            </div>
          ))}
        </div>
        
        <div className="text-center mt-12">
          <Link
            to="/courses"
            className="bg-secondary text-white px-8 py-3 rounded-lg hover:bg-orange-600 transition-colors font-semibold"
          >
            View All Courses
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CourseCards;